<div class="container-fluid maap-root-container">
    <!-- <app-header></app-header> -->
    <div class="container h-100 mt-5">
        <div class="row h-50  justify-content-center align-items-center" >
            <div class="col-md-6  text-center "><div class="maap-root-grid-nav selected m-auto">
                   <h4 class="mt-5">NURSING</h4> 
            </div>
        </div>
            <div class="col-md-6 text-center"><div class="maap-root-grid-nav m-auto">
                <h4 class="mt-5 text-secondary">PHARMACY</h4> 
        </div></div>
            <div class="col-md-6 text-center"><div class="maap-root-grid-nav m-auto">
                <h4 class="mt-5 text-secondary">ANESTHESIA</h4> 
        </div></div>
            <div class="col-md-6 text-center"><div class="maap-root-grid-nav m-auto">
                <h4 class="mt-5 text-secondary">OTHER</h4> 
        </div></div>

        </div>
    </div>
</div>
